const HatWizardDetails = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 19.25c-4.265 0-5.82-1.413-5.983-1.574l-.325-.32L10.535 2.75h5.237l-3.25 2.312 4.784 12.297-.323.317c-.163.161-1.718 1.574-5.983 1.574Zm-4.66-2.312c.605.344 2.031.937 4.66.937 2.632 0 4.055-.593 4.662-.94L11.069 5.118l-4.728 11.82Zm6.035-.438a2.062 2.062 0 0 1 0-4.125c.18 0 .35.03.516.072a2.745 2.745 0 0 0-4.641 1.99 2.745 2.745 0 0 0 4.64 1.99c-.167.047-.34.071-.515.073ZM11 8.937a.69.69 0 0 1 .688.688.69.69 0 0 1-.688.688.69.69 0 0 1-.688-.688.69.69 0 0 1 .688-.688Zm2.063 4.813a.69.69 0 0 1 .687.688.69.69 0 0 1-.688.687.69.69 0 0 1-.687-.688.69.69 0 0 1 .688-.687Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default HatWizardDetails;
